export default "__VITE_ASSET__4e209c6b__"